import Vue from "vue";
import Router from "vue-router";

//首页
const Home = () =>
    import("../views/home/home.vue");

//微信页认证
const WxAuth = () =>
    import("../views/home/auth.vue");

//专场拍卖相关
const Auction = () =>
    import("../views/auction/index.vue");
const AuctionIndex = () =>
    import("../views/auction/auction.vue");
const Yupai = () =>
    import("../views/auction/yupai.vue");
const End = () =>
    import("../views/auction/end.vue");
const Detail = () =>
    import("../views/auction/detail.vue");
const Item = () =>
    import("../views/Auction/item.vue");
const Activity = () =>
    import("../views/Auction/activity.vue");
const Msg_success = resolve =>
    require(["../views/auction/success.vue"], resolve);

//大家拍相关
const Everybody = () =>
    import("../views/everybody/index.vue");
//资讯相关
const Information = () =>
    import("../views/information/index.vue");
const InformationDetail = () =>
    import("../views/information/detail.vue");
//艺术家相关
const Verify = () =>
    import("../views/everybody/verify.vue");
const Publish = () =>
    import("../views/everybody/publish.vue");
const Artistpage = () =>
    import("../views/everybody/artistpage.vue");
const Artistcenter = () =>
    import("../views/everybody/artistcenter.vue");
const ArtistUserOrderList = () =>
    import("../views/everybody/userorderlist.vue");
const plistAll = () =>
    import("../views/everybody/all.vue");
const Deliver = () =>
    import("../views/everybody/deliver.vue");
const Honorary = () =>
    import("../views/everybody/honorary.vue");
const AllArtist = () =>
    import("../views/artist/all.vue");

//订单，支付相关
const Orderlist = () =>
    import("../views/userCenter/orderlist.vue");
const Wuliu = () =>
    import("../views/usercenter/wuliu.vue");
const PaymentIndex = () =>
    import("../views/payment/index.vue");

const Checkout = () =>
    import("../views/payment/checkout.vue");
const Depcustomer = () =>
    import("../views/payment/depcustomer.vue");
const Deposit = () =>
    import("../views/payment/deposit.vue");
const PaymentSuccess = () =>
    import("../views/payment/success.vue");

//个人中心相关
const UserCenter = () =>
    import("../views/userCenter/index.vue");
const Address = () =>
    import("../views/userCenter/address.vue");
const Mybid = () =>
    import("../views/usercenter/mybid.vue");
const Myfav = () =>
    import("../views/usercenter/myfav.vue");
const Historys = () =>
    import("../views/usercenter/history.vue");

const MyLikeArtistList = () =>
    import("../views/usercenter/myLikeArtistList.vue");
const Kefu = () =>
    import("../views/usercenter/kefu.vue");
const Orderdetail = () =>
    import("../views/usercenter/Orderdetail.vue");

//秒杀相关
const Seckill = () =>
    import("../views/Seckill/index.vue");
const SeckillHome = () =>
    import("../views/Seckill/home.vue");
const SeckillItem = () =>
    import("../views/Seckill/item.vue");
const Yizhe = () =>
    import("../views/Seckill/yizhe.vue");
//折扣作品相关
const SaleIndex = () =>
    import("../views/onSale/index.vue");
const SaleItem = () =>
    import("../views/onSale/item.vue");

//商城相关
const MallIndex = () =>
    import("../views/Mall/index.vue");
const MallItem = () =>
    import("../views/Mall/item.vue");
const MarkdownItem = () =>
    import("../views/Mall/markdownItem.vue");
const MallDiscount = () =>
    import("../views/Mall/active/discount.vue");

const FlashItem = () =>
    import("../views/flash/item.vue");

const ExhibitItem = () =>
    import("../views/activity/exhibit.vue");
//逸品汇
const Yipinhui = () =>
    import("../views/yipinhui/index.vue");
const YPHdetail = () =>
    import("../views/yipinhui/detail.vue");
const YPHgoods = () =>
    import("../views/yipinhui/goods.vue");
const Preferred = () =>
    import("../views/yipinhui/preferred.vue");

//客服相关
const Consumer = resolve => require(["../views/service/consumer.vue"], resolve);
const HelpCenter = resolve =>
    require(["../views/service/helpCenter.vue"], resolve);
const ServiceDetail = resolve =>
    require(["../views/service/detail.vue"], resolve);

//资产相关
const Assets = resolve => require(["../views/asset/index.vue"], resolve);
const Bankcard = resolve => require(["../views/asset/bankcard.vue"], resolve);
const Settled = resolve => require(["../views/asset/settled.vue"], resolve);
const Specification = resolve =>
    require(["../views/asset/specification.vue"], resolve);
//登陆注册相关
const Login = resolve => require(["../views/userCenter/login.vue"], resolve);
const BindPhone = resolve =>
    require(["../views/userCenter/bindPhone.vue"], resolve);

//私人定制
const Customize = resolve => require(["../views/customize/index.vue"], resolve);

//新手指南
const Guide = resolve => require(["../views/home/guide.vue"], resolve);

//search相关
const Search = resolve => require(["../views/home/search.vue"], resolve);
const SearchResult = resolve =>
    require(["../views/home/searchResult.vue"], resolve);

//直播
const LiveTest = resolve => require(["../views/live/test.vue"], resolve);
const LiveMy = resolve => require(["../views/live/my.vue"], resolve);
const LiveOption = resolve => require(["../views/live/start.vue"], resolve);
const LiveRoom = resolve => require(["../views/live/room.vue"], resolve);
const LiveShow = resolve => require(["../views/live/show.vue"], resolve);
const LiveIndex = resolve => require(["../views/live/index.vue"], resolve);

//积分兑换
const JifenIndex = resolve => require(["../views/jifen/index.vue"], resolve);
const JifenMy = resolve => require(["../views/jifen/my.vue"], resolve);
const JifenList = resolve => require(["../views/jifen/integral.vue"], resolve);
const JifenExList = resolve => require(["../views/jifen/ex_list.vue"], resolve);
const JifenGift = resolve => require(["../views/jifen/gift.vue"], resolve);
const JifenExStatus = resolve => require(["../views/jifen/status.vue"], resolve);
const JifenOrderdetail = () =>
    import("../views/jifen/orderdetail.vue");

//落地页
const Land2019 = resolve => require(["../views/home/land2019.vue"], resolve);

//新人专享活动页
const Hellonewpage = resolve =>
    require(["../views/home/hellonewpage.vue"], resolve);

// 活动页
const ActPage = resolve => require(["../views/activity/actPage.vue"], resolve);
const PokerCards = resolve =>
    require(["../views/activity/pokerCards.vue"], resolve);
const PokerCardsPrize = resolve =>
    require(["../views/activity/prize.vue"], resolve);
const ReceivePrize = resolve =>
    require(["../views/activity/receivePrize.vue"], resolve);
const ContractArt = resolve =>
    require(["../views/activity/contractArt.vue"], resolve);
const OfflineSpecial = resolve =>
    require(["../views/activity/offlineSpecial.vue"], resolve);
const Markdown = resolve =>
    require(["../views/activity/markdown.vue"], resolve);

//debugger页
const Testauth = resolve => require(["../views/home/testauth.vue"], resolve);
let roterMode = process.env.ROUTER_MODE;
Vue.use(Router);
export default new Router({
    //mode: 'history',
    mode: roterMode === "hash" ? "hash" : "history",
    base: roterMode === "hash" ? "/content/2.0/dist" : "/", //这里面一般填写网站的子目录，如果部署到跟目录 则不需要
    routes: [{
        path: "",
        redirect: "/home"
    },
    {
        path: "/home",
        name: "home",
        component: Home,
        meta: {
            title: "杏坛艺拍---买卖书画上杏坛艺拍",
            keepAlive: true // 需要缓存
        }
    },
    {
        path: "/home/land2019",
        name: "land2019",
        component: Land2019,
        meta: {
            title: "杏坛艺拍---买卖书画上杏坛艺拍"
        }
    },
    {
        path: "/home/guide",
        name: "guide",
        component: Guide,
        meta: {
            title: "新手指南"
        }
    },
    {
        path: "/home/hellonewpage",
        name: "hellonewpage",
        component: Hellonewpage,
        meta: {
            title: "新人专享"
        }
    },
    {
        path: "/home/auth",
        name: "wxauth",
        component: WxAuth,
        meta: {
            title: "正在登录"
        }
    },
    {
        path: "/home/search",
        name: "search",
        component: Search,
        meta: {
            title: "搜索"
        }
    },
    {
        path: "/home/searchResult",
        name: "searchResult",
        component: SearchResult,
        meta: {
            title: "搜索结果"
            //keepAlive: true // 需要缓存
        }
    },
    {
        path: "/home/testauth",
        name: "testauth",
        component: Testauth,
        meta: {
            title: "测试登陆连接"
        }
    },
    {
        path: "/auction",
        name: "index",
        component: Auction,
        meta: {
            title: "专场",
            keepAlive: true, // 需要缓存
            isNeedRefresh: true //是否需要刷新
        },
        children: [{
            path: "",
            name: "auction",
            components: {
                auction: AuctionIndex
            },
            meta: {
                title: "正在拍卖",
                keepAlive: true, // 需要缓存
                isNeedRefresh: true //是否需要刷新
            }
        },
        {
            path: "yupai",
            name: "yupai",
            components: {
                auction: Yupai
            },
            meta: {
                title: "即将开始",
                keepAlive: true, // 需要缓存
                isNeedRefresh: true //是否需要刷新
            }
        },
        {
            path: "end",
            name: "end",
            components: {
                auction: End
            },
            meta: {
                title: "已结束",
                keepAlive: true, // 需要缓存
                isNeedRefresh: true //是否需要刷新
            }
        },
        {
            path: "activity",
            name: "activity",
            components: {
                activity: Activity
            },
            meta: {
                title: "热门活动",
                keepAlive: true, // 需要缓存
                isNeedRefresh: true //是否需要刷新
            }
        }
        ]
    },
    {
        path: "/auction/detail",
        name: "auctionDetail",
        component: Detail,
        meta: {
            title: "详情",
            keepAlive: true, // 需要缓存
            isNeedRefresh: true //是否需要刷新
        }
    },
    {
        path: "/auction/item",
        name: "item",
        component: Item,
        meta: {
            title: "作品详情"
            // requiresAuth: true
        }
    },
    {
        path: "/auction/success",
        name: "msg_success",
        component: Msg_success,
        meta: {
            title: "出价成功"
            // requiresAuth: true
        }
    },
    {
        path: "/everybody",
        name: "everybody",
        component: Everybody,
        meta: {
            title: "大家拍",
            keepAlive: true, // 需要缓存
            isNeedRefresh: true //是否需要刷新
        }
    },
    {
        path: "/information",
        name: "information",
        component: Information,
        meta: {
            title: "资讯"
            //keepAlive: true, // 需要缓存
            //isNeedRefresh: true //是否需要刷新
        }
    },
    {
        path: "/info/detail",
        name: "informationdetail",
        component: InformationDetail,
        meta: {
            title: "资讯详情"
            //keepAlive: true, // 需要缓存
            //isNeedRefresh: true //是否需要刷新
        }
    },
    {
        path: "/everybody/verify",
        name: "verify",
        component: Verify,
        meta: {
            title: "认证",
            requiresAuth: true
        }
    },
    {
        path: "/everybody/publish",
        name: "publish",
        component: Publish,
        meta: {
            title: "发布拍品",
            requiresAuth: true
        }
    },
    {
        path: "/everybody/artistpage",
        name: "artistdetail",
        component: Artistpage,
        meta: {
            title: "艺术家主页",
            keepAlive: true, // 需要缓存
            isNeedRefresh: false
        }
    },
    {
        path: "/everybody/artistcenter",
        name: "artistcenter",
        component: Artistcenter,
        meta: {
            title: "艺术家个人中心",
            requiresAuth: true
        }
    },
    {
        path: "/everybody/userorderlist",
        name: "userOrderList",
        component: ArtistUserOrderList,
        meta: {
            title: "用户订单",
            requiresAuth: true
        }
    },
    {
        path: "/everybody/all",
        name: "plistAll",
        component: plistAll,
        meta: {
            title: "全部作品",
            requiresAuth: true
        }
    },
    {
        path: "/everybody/deliver",
        name: "deliver",
        component: Deliver,
        meta: {
            title: "订单详情",
            requiresAuth: true
        }
    },
    {
        path: "/everybody/honorary",
        name: "honorary",
        component: Honorary,
        meta: {
            title: "艺拍认证"
        }
    },
    {
        path: "/usercenter",
        name: "usercenter",
        component: UserCenter,
        meta: {
            title: "个人中心",
            requiresAuth: true,
            keepAlive: true, // 需要缓存
            isNeedRefresh: true //是否需要刷新
        }
    },
    {
        path: "/usercenter/login",
        name: "login",
        component: Login,
        meta: {
            title: "登陆"
        }
    },
    {
        path: "/usercenter/bindPhone",
        name: "bindPhone",
        component: BindPhone,
        meta: {
            title: "绑定手机",
            requiresAuth: true
        }
    },
    {
        path: "/usercenter/address",
        name: "address",
        component: Address,
        meta: {
            title: "地址管理",
            requiresAuth: true
        }
    },
    {
        path: "/usercenter/orderlist",
        name: "orderlist",
        component: Orderlist,
        meta: {
            title: "订单列表",
            requiresAuth: true
        }
    },
    {
        path: "/usercenter/mybid",
        name: "mybid",
        component: Mybid,
        meta: {
            title: "我的出价",
            requiresAuth: true
        }
    },
    {
        path: "/usercenter/myfav",
        name: "myfav",
        component: Myfav,
        meta: {
            title: "我的收藏",
            requiresAuth: true
        }
    },
    {
        path: "/usercenter/history",
        name: "history",
        component: Historys,
        meta: {
            title: "浏览足迹",
            requiresAuth: true
        }
    },

    {
        path: "/usercenter/myLikeArtistList",
        name: "myLikeArtistList",
        component: MyLikeArtistList,
        meta: {
            title: "关注的艺术家",
            requiresAuth: true
        }
    },
    {
        path: "/usercenter/wuliu",
        name: "wuliu",
        component: Wuliu,
        meta: {
            title: "物流跟踪"
        }
    },
    {
        path: "/usercenter/kefu",
        name: "kefu",
        component: Kefu,
        meta: {
            title: "客服"
        }
    },
    {
        path: "/usercenter/orderdetail",
        name: "orderdetail",
        component: Orderdetail,
        meta: {
            title: "订单详情"
        }
    },
    {
        path: "/seckill",
        name: "seckill",
        component: Seckill,
        meta: {
            title: "秒杀",
            keepAlive: true, // 需要缓存
            isNeedRefresh: true //是否需要刷新
        }
    },
    {
        path: "/seckill/home",
        name: "seckillFromHome",
        component: SeckillHome,
        meta: {
            title: "秒杀",
            keepAlive: true, // 需要缓存
            isNeedRefresh: true //是否需要刷新
        }
    },
    {
        path: "/seckill/item",
        name: "seckillItem",
        component: SeckillItem,
        meta: {
            title: "秒杀详情"
        }
    },
    {
        path: "/seckill/yizhe",
        name: "yizhe",
        component: Yizhe,
        meta: {
            title: "一折秒杀",
            keepAlive: true, // 需要缓存
            isNeedRefresh: true //是否需要刷新
        }
    },
    {
        path: "/payment/deposit",
        name: "deposit",
        component: Deposit,
        meta: {
            title: "卖家保证金缴纳",
            requiresAuth: true
        }
    },
    {
        path: "/payment/depcustomer",
        name: "depcustomer",
        component: Depcustomer,
        meta: {
            title: "买家保证金",
            requiresAuth: true
        }
    },
    {
        path: "/payment/checkout",
        name: "checkout",
        component: Checkout,
        meta: {
            title: "收银台",
            requiresAuth: true
        }
    },
    {
        path: "/payment/index",
        name: "index",
        component: PaymentIndex,
        meta: {
            title: "支付页",
            requiresAuth: true
        }
    },
    {
        path: "/payment/success",
        name: "index",
        component: PaymentSuccess,
        meta: {
            title: "支付成功",
            requiresAuth: true
        }
    },
    {
        path: "/mall",
        name: "mallIndex",
        component: MallIndex,
        meta: {
            title: "商城",
            keepAlive: true, // 需要缓存
            isNeedRefresh: true //是否需要刷新
        }
    },
    {
        path: "/mall/item",
        name: "mallItem",
        component: MallItem,
        meta: {
            title: "详情"
        }
    },
    {
        path: "/mall/markdownItem",
        name: "mallMarkdownItem",
        component: MarkdownItem,
        meta: {
            title: "详情"
        }
    },
    {
        path: "/mall/active/discount",
        name: "mallDiscount",
        component: MallDiscount,
        meta: {
            title: "商城折扣周"
        }
    },
    {
        path: "/yipinhui",
        name: "Yipinhui",
        component: Yipinhui,
        meta: {
            title: "逸品汇",
            keepAlive: true, // 需要缓存
            isNeedRefresh: true //是否需要刷新
        }
    },
    {
        path: "/yipinhui/detail",
        name: "YPHdetail",
        component: YPHdetail,
        meta: {
            title: "详情",
            keepAlive: true, // 需要缓存
            isNeedRefresh: true //是否需要刷新
        }
    },
    {
        path: "/yipinhui/goods",
        name: "YPHgoods",
        component: YPHgoods,
        meta: {
            title: "作品详情"
        }
    },
    {
        path: "/yipinhui/preferred",
        name: "Preferred",
        component: Preferred,
        meta: {
            title: "逸品汇保证金"
        }
    },
    {
        path: "/flash/item",
        name: "flashItem",
        component: FlashItem,
        meta: {
            title: "详情"
        }
    },
    {
        path: "/activity/exhibit",
        name: "exhibitItem",
        component: ExhibitItem,
        meta: {
            title: "详情"
        }
    },
    {
        path: "/onSale/index",
        name: "SaleIndex",
        component: SaleIndex,
        meta: {
            title: "每日折扣"
        }
    },
    {
        path: "/onSale/item",
        name: "SaleItem",
        component: SaleItem,
        meta: {
            title: "详情"
        }
    },
    {
        path: "/artist/all",
        name: "allArtist",
        component: AllArtist,
        meta: {
            title: "全部艺术家"
        }
    },
    {
        path: "/customize/index",
        name: "Customize",
        component: Customize,
        meta: {
            title: "私人定制"
        }
    },
    {
        path: "/live",
        name: "live",
        component: LiveIndex,
        meta: {
            title: "直播",
            keepAlive: true, // 需要缓存
            isNeedRefresh: true
        }
    },
    {
        path: "/live/room",
        name: "LiveRoom",
        component: LiveRoom,
        meta: {
            title: "房间",
            requiresAuth: true
        }
    },
    {
        path: "/live/show",
        name: "LiveShow",
        component: LiveShow,
        meta: {
            title: "详情"
        }
    },
    {
        path: "/live/my",
        name: "LiveMy",
        component: LiveMy,
        meta: {
            title: "我的直播",
            requiresAuth: true
        }
    },
    {
        path: "/live/option",
        name: "LiveOption",
        component: LiveOption,
        meta: {
            title: "直播设置",
            requiresAuth: true
        }
    },
    {
        path: "/live/test",
        name: "LiveTest",
        component: LiveTest,
        meta: {
            title: "直播设置",
            requiresAuth: true
        }
    },
    {
        path: "/service/consumer",
        name: "consumer",
        component: Consumer,
        meta: {
            title: "客服与帮助（消费者版）",
            keepAlive: true // 需要缓存
        }
    },
    {
        path: "/service/helpCenter",
        name: "helpCenter",
        component: HelpCenter,
        meta: {
            title: "客服与帮助",
            keepAlive: true, // 需要缓存
            isNeedRefresh: true
        }
    },
    {
        path: "/service/detail",
        name: "detail",
        component: ServiceDetail,
        meta: {
            title: "详情"
        }
    },
    {
        path: "/asset",
        name: "asset",
        component: Assets,
        meta: {
            title: "我的资产"
        }
    },
    {
        path: "/asset/bankcard",
        name: "bankcard",
        component: Bankcard,
        meta: {
            title: "我的银行卡"
        }
    },
    {
        path: "/asset/settled",
        name: "settled",
        component: Settled,
        meta: {
            title: "待结算货款"
        }
    },
    {
        path: "/asset/specification",
        name: "specification",
        component: Specification,
        meta: {
            title: "详细信息"
        }
    },
    {
        path: "/jifen",
        name: "jifen",
        component: JifenIndex,
        meta: {
            title: "积分",
            requiresAuth: true
        }
    },
    {
        path: "/jifen/my",
        name: "jifenmy",
        component: JifenMy,
        meta: {
            title: "我的积分",
            requiresAuth: true
        },
        children: [{
            path: "",
            name: "jifenlist",
            component: JifenList
        },
        {
            path: "exlist",
            name: "exlist",
            component: JifenExList
        }
        ]
    },
    {
        path: "/jifen/gift",
        name: "jifengift",
        component: JifenGift,
        meta: {
            title: "礼品详情"
        }
    },
    {
        path: "/jifen/status",
        name: "jifenexstatus",
        component: JifenExStatus,
        meta: {
            title: "兑换状态"
        }
    },
    {
        path: "/jifen/orderdetail",
        name: "jifenorderdetail",
        component: JifenOrderdetail,
        meta: {
            title: "订单详情"
        }
    },
    {
        path: "/activity/actPage",
        name: "actPage",
        component: ActPage,
        meta: {
            title: "活动页",
            keepAlive: true, // 需要缓存
            isNeedRefresh: true
        }
    },
    // {
    //   path: "/activity/pokerCards",
    //   name: "pokerCards",
    //   component: PokerCards,
    //   meta: {
    //     title: "翻牌赢好礼",
    //     keepAlive: true // 需要缓存
    //   }
    // },
    // {
    //   path: "/activity/pokerCards/prize",
    //   name: "pokerCardsPrize",
    //   component: PokerCardsPrize,
    //   meta: {
    //     title: "翻牌赢好礼"
    //   }
    // },
    // {
    //   path: "/activity/pokerCards/receiveprize",
    //   name: "receivePrize",
    //   component: ReceivePrize,
    //   meta: {
    //     title: "兑换奖品"
    //   }
    // },
    {
        path: "/activity/contractArt",
        name: "contractArt",
        component: ContractArt,
        meta: {
            title: "专题页",
            keepAlive: true, // 需要缓存
            isNeedRefresh: false
        }
    },
    {
        path: "/activity/offlineSpecial",
        name: "offlineSpecial",
        component: OfflineSpecial,
        meta: {
            title: "专场详情",
            keepAlive: true // 需要缓存
        }
    },
    {
        path: "/activity/markdown",
        name: "markdown",
        component: Markdown,
        meta: {
            title: "清仓作品列表",
            keepAlive: true, // 需要缓存
            isNeedRefresh:true
        }
    },
    {
        path: "*",
        redirect: "/"
    } //路由按顺序从上到下，依次匹配。最后一个*能匹配全部，然后重定向到主页面
    ]
});